<template>
  <div class="mm-row-block">
    <el-form label-width="100px" label-position="left">
      <div class="form-isheader-group">
        <div class="form-isheader-group-content">
          <div class="mm-row" v-if="data.remittype">
            <div class="mm-col flex50">
              <el-form-item label="匯款方式" prop="remittype">
                <div class="mm-row flex-start">
                  {{data.remittype==0?'現金':'銀行轉賬'}} 
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row">
            <div class="mm-col flex50">
              <el-form-item label="貨幣" prop="account_name">
                <div class="mm-row flex-start">
                  <img style="width: 30px; height: 30px;margin-right:15px;" :src="apiurl+data.currency_thumb">
                  {{data.currency_short_name}}
                  {{data.currency_name}}
                  {{data.money}}
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人賬號" prop="account_num">
                <el-input disabled="" v-model="data.account_num_format">
                  <el-button slot="append" @click="copyText(data.account_num)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人名稱" prop="account_name">
                <el-input disabled="" v-model="data.account_name">
                  <el-button slot="append" @click="copyText(data.account_name)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人電話" prop="phone">
                <el-input disabled="" v-model="data.phone">
                  <el-button slot="append" @click="copyText(data.phone)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input disabled="" v-model="data.id_card"></el-input>
              </el-form-item>
            </div>
          </div> -->

          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行名稱" prop="address">
                <el-input disabled="" v-model="data.hkbankname">
                  <el-button slot="append" @click="copyText(data.hkbankname)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人地址">
                <el-input disabled="" v-model="data.address">
                  <el-button slot="append" @click="copyText(data.address)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行備註">
                <el-input disabled="" v-model="data.remark">
                  <el-button slot="append" @click="copyText(data.remark)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

    </el-form>
  </div>

</template>

<script>

export default {
  props: ['data'],
  name: "bankinfo",
  data () {
    return {
    }
  },
  methods: {
    copyText (text) {
      const oInput = document.createElement('input')
      oInput.value = text;
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      // 提醒信息
      this.$notify({
        message: '複製成功',
        type: 'success',
        duration: 3000,
        offset: 70
      });
      oInput.remove()
    },
  },
  created () {
    this.data.account_num_format = this.addSpace(this.data.account_num_format);
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
.flex-start {
  justify-content: start;
}
</style>
